import { useEffect, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const CLIENT_ID =
  "1092031731388-757d71hep83rjpbkgteavsetjcnft332.apps.googleusercontent.com";

const GoogleOneTap = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        console.log("QUI RICHIESTA");

        const response = await axios.get(`${API_URL}/api/verifyLogin`, {
          withCredentials: true,
        });
        console.log("Data:", response);
        if (response) {
          setIsLoggedIn(true);
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          console.log("NON AUTENTICATO");
          setIsLoggedIn(false);
        }
      }
    };
    checkAuth();
  }, []);

  useEffect(() => {
    if (!isLoggedIn) {
      window.google?.accounts.id.initialize({
        client_id: CLIENT_ID,
        callback: handleLoginSuccess,
      });

      window.google?.accounts.id.prompt(); // Mostra il pop-up
    }
  }, [isLoggedIn]);

  const handleLoginSuccess = async (response) => {
    try {
      console.log("Login Success:", response);
      const googleToken = response.credential;

      const res = await axios.post(`${API_URL}/api/google-login`, {
        token: googleToken,
      });

      console.log("Response from backend:", res.data);

      if (res.status === 200) {
        if (res.data.user) {
          localStorage.setItem("user", JSON.stringify(res.data.user));
        }

        setIsLoggedIn(true);
        window.location.reload();
      } else {
        console.error("Errore durante l'autenticazione:", res.status, res.data);
      }
    } catch (error) {
      console.error("Errore:", error.message || error);
    }
  };
};

export default GoogleOneTap;
